import React, { Component } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import Projects from './Components/Projects';
import NavBar from './Components/NavBar';
import GiftPlannerPolicies from './Components/GiftPlannerPolicies';
import Maintenance from './Components/Maintenance';
import FoodRecipesPolicies from './Components/FoodRecipesPolicies';
import PageNotFount from './Components/NotFound';
import Contact from './Components/Contact';
import DetailView from './Components/DetailView';
import Portrait from './Components/Portrait';
import TickFlipPrivacyPolicy from './Components/TickFlipPrivacyPolicy';
import RopefitPolicies from './Components/RopefitPolicies';
import Footer from './Components/Footer';
import ScrollToTop from './Components/ScrollToTop';

class App extends Component {
  render() {
    return (
      <main className='site-layout'>
        <ScrollToTop />
        <NavBar />
        <div className='container flex-shrink-0 body'>
          <Routes>
            <Route path='/maintenance' element={<Maintenance />} />
            <Route path='/gallery/:index' element={<DetailView />} />
            <Route path='/apps' element={<Projects />} />
            <Route path='/portrait' element={<Portrait />} />
            <Route
              path='/food-recipes-policies'
              element={<FoodRecipesPolicies />}
            />
            <Route
              path='/tickflipclock-policy'
              element={<TickFlipPrivacyPolicy />}
            />
            <Route path='/policies' element={<GiftPlannerPolicies />} />
            <Route path='/ropefit-policy' element={<RopefitPolicies />} />
            <Route path='/notfound' element={<PageNotFount />} />
            <Route path='/' element={<Contact />} />
            <Route path='*' element={<Navigate to='/notfound' />} />
          </Routes>
        </div>
        <Footer />
      </main>
    );
  }
}

export default App;
